import "./components/dropdown.js";
import "./components/navigation.js";
import "./components/libraries/sticky.js";

import Rails from "@rails/ujs";

Rails.start();
